import { useTranslation } from 'react-i18next';
import { IconAlertTriangle } from '@tabler/icons-react';
import GateBanner from '@/components/common/GateBanner';
import { ROUTES } from '@/routes/paths';

// Ограничение создания прайс-листов до аттестации: не аттестованный покупатель видит баннер вместо
// действия создания (просмотр рынка остаётся доступен). Вид — общий GateBanner, диплинк в
// «Моя компания → Аттестация».
export default function BuyAttestationGate() {
  const { t } = useTranslation();
  return (
    <GateBanner
      icon={<IconAlertTriangle size={20} />}
      to={ROUTES.APP_COMPANY_ACCREDITATION}
      title={t('app.buy.attestationGate.title')}
      text={t('app.buy.attestationGate.text')}
      action={t('app.buy.attestationGate.action')}
    />
  );
}
